import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../store/hooks";
import { BillValidationPayload } from "features/bbps/biller/billerFlowTypes";
import {
  billValidationRequested,
  billValidationReset,
} from "store/bbps/billValidation/billValidationSlice";
import { RootState } from "store/rootReducer";

export function useBillValidation() {
  const dispatch = useAppDispatch();
  const state = useSelector((s: RootState) => s.billValidation);

  const validateBill = useCallback(
    (payload: BillValidationPayload) => {
      dispatch(billValidationRequested(payload));
    },
    [dispatch],
  );

  const resetValidation = useCallback(() => {
    dispatch(billValidationReset());
  }, [dispatch]);

  // const validateBillResponse = useCallback(
  //   () => {
  //     dispatch(billValidationRequested());
  //   },
  //   [dispatch]
  // );
  return {
    ...state, // { loading, data, error }
    validateBill,
    resetValidation,
  };
}
